import * as React from "react";

import { cn } from "lib/utils";

export interface MutedInsetProps extends React.HTMLAttributes<HTMLDivElement> {
    padding?: "sm" | "md";
}

const paddingClass = {
    sm: "p-3",
    md: "p-4",
} as const;

export const MutedInset = React.forwardRef<HTMLDivElement, MutedInsetProps>(
    ({ className, padding = "sm", ...props }, ref) => (
        <div ref={ref} className={cn("rounded-xl bg-muted/40", paddingClass[padding], className)} {...props} />
    ),
);
MutedInset.displayName = "MutedInset";
